var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "col-lg-offset-1 col-md-offset-1", attrs: { md: "11" } },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(
                      "Valitse teetkö sopimuksen uudelle käyttöpaikallesi PKS:n kanssa. Sähkösopimus pitää olla tehtynä ennen kuin sähköt kytketään."
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "radio" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newContractMode,
                        expression: "newContractMode"
                      }
                    ],
                    attrs: { type: "radio", id: "PTsel1", name: "ProcessType" },
                    domProps: {
                      value: _vm.ProcessTypeEnum.MOVINGPROCESS,
                      checked: _vm._q(
                        _vm.newContractMode,
                        _vm.ProcessTypeEnum.MOVINGPROCESS
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveNewContractModeSelection(1)
                      },
                      change: function($event) {
                        _vm.newContractMode = _vm.ProcessTypeEnum.MOVINGPROCESS
                      }
                    }
                  }),
                  _vm._v(
                    " Teen uuden sopimuksen PKS:n kanssa\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio" }, [
                _c("label", { staticClass: "radio-inline" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newContractMode,
                        expression: "newContractMode"
                      }
                    ],
                    attrs: { type: "radio", id: "PTsel2", name: "ProcessType" },
                    domProps: {
                      value: _vm.ProcessTypeEnum.CONTRACTPROCESS,
                      checked: _vm._q(
                        _vm.newContractMode,
                        _vm.ProcessTypeEnum.CONTRACTPROCESS
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveNewContractModeSelection(2)
                      },
                      change: function($event) {
                        _vm.newContractMode =
                          _vm.ProcessTypeEnum.CONTRACTPROCESS
                      }
                    }
                  }),
                  _vm._v(
                    " Jatkan nykyistä sopimustani PKS:n kanssa\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio-inline" }, [
                _c("label", { staticClass: "radio-inline" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newContractMode,
                        expression: "newContractMode"
                      }
                    ],
                    staticClass: "contract-field",
                    attrs: { type: "radio", id: "PTsel3", name: "ProcessType" },
                    domProps: {
                      value: _vm.ProcessTypeEnum.MOVEOUT,
                      checked: _vm._q(
                        _vm.newContractMode,
                        _vm.ProcessTypeEnum.MOVEOUT
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveNewContractModeSelection(3)
                      },
                      change: function($event) {
                        _vm.newContractMode = _vm.ProcessTypeEnum.MOVEOUT
                      }
                    }
                  }),
                  _vm._v(" En tee sopimusta PKS:n kanssa\n                ")
                ])
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }